import styled from "styled-components";
import ReactMapGL from "react-map-gl";

export const MapContent = styled.div`
	height: 300px;
	margin: 60px 140px 0 140px;
	h1 {
		color: var(--darkGrey);
		text-align: center;
		padding-bottom: 70px;
	}

	.mapboxgl-popup-content {
		border-radius: 25px;
	}

	.mapboxgl-popup-close-button {
		background-color: red;
		width: 40px;
		border-radius: 0 0 0 50px;
		font-weight: bold;
		font-size: var(--fontBig);
	}

	@media screen and (max-width: 780px) {
		margin: 0 30px 200px 30px;
	}
`;

export const ReactMapGLKoka = styled(ReactMapGL)`
	border-radius: 25px;
`;

export const MapLogo = styled.img`
	cursor: pointer;
	animation: bounce 1.5s linear;
	-webkit-animation: bounce 1.5s infinite;
	-moz-animation: bounce 1.5s infinite;
	-o-animation: bounce 1.5s infinite;

	@-webkit-keyframes bounce {
		0%,
		20%,
		50%,
		80%,
		100% {
			-webkit-transform: translateY(0);
		}
		40% {
			-webkit-transform: translateY(-30px);
		}
		60% {
			-webkit-transform: translateY(-15px);
		}
	}
	@-moz-keyframes bounce {
		0%,
		20%,
		50%,
		80%,
		100% {
			-moz-transform: translateY(0);
		}
		40% {
			-moz-transform: translateY(-30px);
		}
		60% {
			-moz-transform: translateY(-15px);
		}
	}
	@-o-keyframes bounce {
		0%,
		20%,
		50%,
		80%,
		100% {
			-o-transform: translateY(0);
		}
		40% {
			-o-transform: translateY(-30px);
		}
		60% {
			-o-transform: translateY(-15px);
		}
	}
	@keyframes bounce {
		0%,
		20%,
		50%,
		80%,
		100% {
			transform: translateY(0);
		}
		40% {
			transform: translateY(-30px);
		}
		60% {
			transform: translateY(-15px);
		}
	}

	&:hover {
		animation-play-state: paused;
	}
	&:active {
		animation-play-state: paused;
	}
`;

export const PopUpLocation = styled.div`
	margin-top: 10px;
	cursor: default;
	display: flex;
	justify-content: space-between;
	gap: 10px;
	align-items: center;
	flex-direction: column;

	h2 {
		margin-top: 10px;
		color: black;
		font-size: var(--fontMed);
	}

	p {
		color: var(--darkGrey);
		font-size: 12px;
	}

	a {
		background-color: var(--darkGrey);
		color: var(--white);
		padding: 10px 20px;
		border-radius: 20px;
		text-decoration: none;
	}
`;
